import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { UserService } from 'src/app/core/services/user.service';
import { Pedido } from '../../pedido/models/pedido';
import { PedidoProduto } from '../../pedido/models/pedido-produto';
import { PedidoStatusFluxo } from '../../pedido/models/pedido-status-fluxo';
import { PedidoStatusHistorico } from '../../pedido/models/pedido-status-historico';
import { PedidoService } from '../../pedido/pedido.service';
import { Atributo } from '../../pessoa/models/atributo';
import { Endereco } from '../../pessoa/models/endereco';
import { PessoaService } from '../../pessoa/pessoa.service';

@Component({
  selector: 'app-evento-pedido-detalhe',
  templateUrl: './evento-pedido-detalhe.component.html',
  styleUrls: ['./evento-pedido-detalhe.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EventoPedidoDetalheComponent implements OnInit {

  
  private idPedido : string = "0";
  private idPessoa : string = "0";
  private idUsuario : number = 0;
  public itemPedido: Pedido;    
  public isDisabled: boolean = true;
  public listaEndereco: Endereco[] = [];  
  public listaAtributo: Atributo[] = [];  
  public listaStatus: PedidoStatusHistorico[] = [];
  public listaStatusFluxo: PedidoStatusFluxo[] = [];
  public listaProduto: PedidoProduto[] = [];
  b:any;
  a:any;
  value1:any;
  flVendaOptions: any[];
  flFreteOptions: any[];
  
  constructor(public pedidoService: PedidoService, 
                  private router: Router, 
                  private route: ActivatedRoute,  
                  private messageService: MessageService,
                  public pessoaService: PessoaService,                    
                  private activateRoute: ActivatedRoute,
                  private userService: UserService
              ) { }


  ngOnInit(): void {      
      
    this.idPedido = this.route.snapshot.paramMap.get("id");

    this.idUsuario = this.userService.getUserId(); 

    //this.getPedido(this.idPedido);  Pega do Resolver      
    this.itemPedido = this.activateRoute.snapshot.data['Pedido'];
    
    this.getPessoaEndereco(this.itemPedido.idPessoa);
    this.getPessoaAtributo(this.itemPedido.idPessoa);
    this.getPedidoListaStatusFluxo(this.itemPedido.idPedidoStatus, this.idUsuario.toString()); 
    this.getPedidoListaStatus(this.idPedido);
    this.getPedidoListaProduto(this.idPedido);

    
    this.flVendaOptions = [{label: 'Sim', value: 'true'}, {label: 'Não', value: 'false'}];
    this.flFreteOptions = [{label: 'Sim', value: 'true'}, {label: 'Não', value: 'false'}];
    

}


  getPedido(idPedido){      

      this.pedidoService.getPedido(idPedido).subscribe(
          (res) => {
              if (res) {        
                  this.itemPedido = res;                       
                  this.getPessoaEndereco(this.itemPedido.idPessoa);
                  this.getPessoaAtributo(this.itemPedido.idPessoa);
                  this.getPedidoListaStatusFluxo(this.itemPedido.idPedidoStatus, this.idUsuario.toString());                                                       
   
              }
          },
          err => {                
              console.log("ERRO PEDIDO-DETALHE: " + err);
          }
      );
  }

  getPedidoListaStatus(idPedido){              

    this.pedidoService.getPedidoListaStatus(idPedido).subscribe(
           (res) => {
               if (res) {     
                  this.listaStatus = res;                                                                               
               }
           },
           err => {                
               console.log("ERRO PEDIDO-DETALHE: " + err);
           }
       ); 
}

getPedidoListaProduto(idPedido){              

  this.pedidoService.getPedidoProdutoLista(idPedido).subscribe(
         (res) => {
             if (res) {     
                this.listaProduto = res;  
                console.log('pro'+this.listaProduto);                                                                             
             }
         },
         err => {                
             console.log("ERRO PEDIDO-PRODUTO: " + err);
         }
     ); 
}

getPedidoListaStatusFluxo(idPedidoStatus: string, idUsuario: string){      

  this.pedidoService.getPedidoListaStatusFluxo(idPedidoStatus, idUsuario).subscribe(
         (res) => {
             if (res) {                                       
                 this.listaStatusFluxo = res;                                                                                              
                
             }
         },
         err => {                
             console.log("ERRO PEDIDO-STATUS-FLUXO: " + err);
         }
     ); 
}

  getPessoaEndereco(idPessoa){      

    this.pessoaService.getPessoaEndereco(idPessoa).subscribe(
        (res) => {
            if (res) {                            
                this.listaEndereco = res;                     
            }
        },
        err => {                
            console.log("ERRO PEDIDO-DETALHE-Endereco: " + err);
        }
    );
}

  getPessoaAtributo(idPessoa){      

      this.pessoaService.getPessoaAtributo(idPessoa).subscribe(
          (res) => {
              if (res) {      
                  this.listaAtributo = res;                                        
              }
          },
          err => {                
              console.log("ERRO PEDIDO-DETALHE-Atributo: " + err);
          }
      );
  }

AtualizarStatus(IdPedidoStatus: string)
{
  this.pedidoService.AtualizaPedidoStatus(this.idPedido, IdPedidoStatus, this.idUsuario, null).subscribe(
    (res) => {
        if (res) {                  
          this.getPedidoListaStatus(this.idPedido);
          this.getPedidoListaStatusFluxo(this.itemPedido.idPedidoStatus, this.itemPedido.idusuario);  
          this.getPedido(this.idPedido);                    
          
        }
    },
    err => {                
        console.log("ERRO PEDIDO-ATUALIZA-STATUS: " + err);
    }
);
}

PdfPedidoClick(idPedido: string)
{
    console.log();
  this.router.navigate(['/pedido-pdf', idPedido])   
}

backClick() {
  this.router.navigate(['/']) 
  
}

}
